// TODO_TYPES: do we want to define data
const setPageTrackingData = (data: any) => {
  if (typeof window !== 'undefined') {
    window.currentPageTrackingData = { ...data };
  }
};

export default setPageTrackingData;
